import useSWR from 'swr'

import { fetchData } from 'facades/fetchDocuments'
import { fetchLoanApplication } from 'facades/fetchLoanApplication'

const useFetchDocuments = (applicationId: string) => {
  const { data: loanApplication } = useSWR(
    ['loan-application', applicationId],
    () => fetchLoanApplication(applicationId),
  )
  const { data } = useSWR(['documents', applicationId], () =>
    fetchData(applicationId, loanApplication.peopleId),
  )

  return data
}

export { useFetchDocuments }
